import { render, staticRenderFns } from "./ImportBox.vue?vue&type=template&id=1bbc1db1&scoped=true"
import script from "./ImportBox.vue?vue&type=script&lang=js"
export * from "./ImportBox.vue?vue&type=script&lang=js"
import style0 from "./ImportBox.vue?vue&type=style&index=0&id=1bbc1db1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbc1db1",
  null
  
)

export default component.exports